/* eslint-disable complexity */
import React, { Suspense } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import get from 'lodash.get'

import './theme/variables.css'

import { PaymentSource } from './interfaces'
import serverData from './utils/server-data'

import './app.css'

import { useQuery } from './hooks'
import {
  /* istanbul ignore next */
  Giropay,
  P24,
  Ideal,
  Eps,
  Mybank,
  Bancontact,
  Blik,
  Trustly,
  Verkkopankki,
  Payu,
  /* istanbul ignore next */
  Boleto,
  Oxxo,
  Multibanco,
  Alipay,
  Wechatpay,
  Satispay,
  Paidy
} from './paymentSources'

import { loadTheme } from './theme'

import { loadXPropsMock } from './mocks'

const Preview = React.lazy(() => import('./preview'))
const Themes = React.lazy(() => import('./theme/views'))

if (!(window as any).xprops) {
  loadXPropsMock()
}

export function Paymentfields() {
  // Load the theme
  React.useEffect(() => {
    const theme = get(window, 'xprops.style', {
      variables: {},
      rules: {},
    })

    loadTheme(theme)
  }, [])

  const query = useQuery()
  const fundingSource = query.get('fundingSource') as PaymentSource

  switch (fundingSource) {
    case PaymentSource.Ideal:
      return <Ideal />
    case PaymentSource.Eps:
      return <Eps />
    case PaymentSource.P24:
      return <P24 />
    case PaymentSource.Mybank:
      return <Mybank />
    case PaymentSource.Trustly:
      return <Trustly />
    /* istanbul ignore next */
    case PaymentSource.Giropay:
    /* istanbul ignore next */
      return <Giropay />
    case PaymentSource.Bancontact:
      return <Bancontact />
    case PaymentSource.Blik:
      return <Blik />
    case PaymentSource.Verkkopankki:
      return <Verkkopankki />
    case PaymentSource.Payu:
      return <Payu />
    /* istanbul ignore next */
    case PaymentSource.Boleto:
    /* istanbul ignore next */
    return <Boleto />
    case PaymentSource.Oxxo:
      return <Oxxo />
    case PaymentSource.Multibanco:
      return <Multibanco />
    case PaymentSource.Alipay:
      return <Alipay />
    case PaymentSource.Wechatpay:
      return <Wechatpay />
    case PaymentSource.Satispay:
      return <Satispay />
    case PaymentSource.Paidy:
      return <Paidy />
    default:
      return serverData.isSandBox || serverData.isProd ? <div /> : <Preview />
  }
}

export default function App() {
  return (
    <Suspense fallback={<div />}>
      <Router>
        <div>
          <Switch>
            <Route component={Themes} path="/altpayfields/themes/:theme" />

            <Route path="/altpayfields">
              <Paymentfields />
            </Route>
          </Switch>
        </div>
      </Router>
    </Suspense>
  )
}
